<script>
    import FortuneWheel from './FortuneWheel.svelte';
    export let allPrizes;
    export let availablePrizes;
    export let showBuyMoreSpinsBtn;
    export let buyMoreSpinsUrl;
    export let availableSpins;
    export let collectedCodes;
</script>



<FortuneWheel {showBuyMoreSpinsBtn} {buyMoreSpinsUrl} {availableSpins} {collectedCodes} {allPrizes} {availablePrizes} />